<template>
  <single-image
    :schema="schema"
    :mediaURL="mediaURL"
    :queryString="queryString"
    @error="handleError"
  ></single-image>
</template>

<script>
import { SingleImage } from '@witkac/vue-images';

import { uploadMixin } from '@/mixins/upload';

// @vuese
// @group Components/Forms
// Input na obrazki
export default {
  mixins: [uploadMixin],
  components: { SingleImage }
};
</script>
